<template>
  <div class="login-container">
    <!-- 自定义导航栏 -->
    <div class="nav-header">
      <div class="nav-content">
        <div class="logo">
          <span class="logo-text">泰跃卫星</span>
          <span class="logo-subtitle">后台管理系统</span>
        </div>
        <div class="nav-actions">
          <el-button type="text" @click="$router.push('/')">返回网站</el-button>
        </div>
      </div>
    </div>

    <!-- 登录主体 -->
    <div class="login-main">
      <div class="login-bg">
        <div class="login-bg-pattern"></div>
      </div>
      <div class="login-form-wrapper">
        <div class="login-form-card">
          <div class="login-header">
            <h2 class="login-title">管理员登录</h2>
            <p class="login-subtitle">请使用管理员账号登录系统</p>
          </div>

          <el-form
            :model="form"
            :rules="rules"
            ref="form"
            class="login-form"
            label-position="top"
          >
            <el-form-item label="用户名" prop="username">
              <el-input
                v-model="form.username"
                placeholder="请输入用户名"
                prefix-icon="el-icon-user"
                autocomplete="off"
                size="large"
              ></el-input>
            </el-form-item>

            <el-form-item label="密码" prop="password">
              <el-input
                v-model="form.password"
                type="password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                autocomplete="off"
                size="large"
                @keyup.enter.native="handleLogin"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                :loading="loading"
                @click="handleLogin"
                class="login-btn"
                size="large"
              >
                <i class="el-icon-s-promotion"></i>
                登录系统
              </el-button>
            </el-form-item>
          </el-form>

          <div class="login-footer">
            <p>泰跃卫星技术发展股份有限公司</p>
            <p>© 2026 All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { mapMutations } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    ...mapMutations(['setAuth']),
    handleLogin() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const res = await request.post('/auth/login', this.form)
          if (res.success) {
            this.setAuth(res.data)
            this.$message.success('登录成功')
            const redirect = this.$route.query.redirect || '/admin'
            this.$router.replace(redirect)
          } else {
            this.$message.error(res.error || '登录失败')
          }
        } catch (error) {
          this.$message.error(error.error || '登录失败')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
}

/* 导航栏样式 */
.nav-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
}

.nav-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  height: 60px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  letter-spacing: -0.5px;
}

.logo-subtitle {
  font-size: 12px;
  color: #7f8c8d;
  background: #ecf0f1;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 500;
}

.nav-actions .el-button {
  color: #667eea;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.nav-actions .el-button:hover {
  background: #667eea;
  color: white;
  transform: translateY(-1px);
}

/* 登录主体样式 */
.login-main {
  display: flex;
  min-height: 100vh;
  padding-top: 60px;
}

.login-bg {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
}

.login-bg-pattern {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}

.login-form-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: white;
}

.login-form-card {
  width: 100%;
  max-width: 420px;
  padding: 48px 40px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.login-form-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2);
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
}

.login-subtitle {
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
}

.login-form .el-form-item {
  margin-bottom: 24px;
}

.login-form .el-form-item__label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 14px;
}

.login-form .el-input {
  border-radius: 12px;
  /* border: 2px solid #ecf0f1; */
  transition: all 0.3s ease;
}

.login-form .el-input:hover {
  border-color: #667eea;
}

.login-form .el-input.is-focus .el-input__inner {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.login-form .el-input__inner {
  font-size: 15px;
  padding: 16px 20px;
  height: auto;
}

.login-form .el-input__prefix {
  left: 16px;
  color: #95a5a6;
}

.login-form .el-input__inner::placeholder {
  color: #bdc3c7;
}

.login-btn {
  width: 100%;
  height: 56px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: all 0.3s ease;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}

.login-btn i {
  margin-right: 8px;
}

.login-footer {
  margin-top: 32px;
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #ecf0f1;
}

.login-footer p {
  margin: 4px 0;
  font-size: 12px;
  color: #95a5a6;
}

.login-footer p:first-child {
  font-weight: 500;
  color: #7f8c8d;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-main {
    flex-direction: column;
  }

  .login-bg {
    min-height: 200px;
  }

  .login-form-card {
    margin: 20px;
    padding: 32px 24px;
  }

  .login-title {
    font-size: 24px;
  }

  .nav-content {
    padding: 12px 16px;
  }

  .logo-text {
    font-size: 18px;
  }

  .logo-subtitle {
    display: none;
  }
}

@media (max-width: 480px) {
  .login-form-card {
    margin: 16px;
    padding: 24px 20px;
  }

  .login-header {
    margin-bottom: 32px;
  }

  .login-form .el-input__inner {
    padding: 14px 16px;
  }

  .login-btn {
    height: 48px;
  }
}
</style>
